var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSendAllToggleOval = function SvgSendAllToggleOval(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 14,
    viewBox: "0 0 34 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 34,
    height: 14,
    rx: 7,
    fill: "#fff"
  })));
};
export { SvgSendAllToggleOval as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAzNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgb3BhY2l0eT0iMC41IiB3aWR0aD0iMzQiIGhlaWdodD0iMTQiIHJ4PSI3IiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";